export class SearchPricingModel {
  constructor(
    public pickupCountry: string | undefined,
    public pickupZipCode: string | undefined,
    public pickupInseeCode: string | undefined,
    public deliveryCountry: string | undefined,
    public deliveryZipCode: string | undefined,
    public deliveryInseeCode: string | undefined,
    public quantity: number | undefined,
    public offerId: number | undefined
  ) {}
}
